export default "__VITE_ASSET__BLnZ76IG__"